// Shared profile/tab form styles from Figma node 4822:47779.
export const PROFILE_COLORS = {
  text: "#344054", label: "#3451F4", link: "#9C4FFF",
  border: "#D2D8DE", muted: "#A2ABB4",
};

export const PROFILE_LABEL_SX = {
  fontFamily: '"Be Vietnam Pro", sans-serif', fontSize: 14, fontWeight: 500,
  color: PROFILE_COLORS.label, lineHeight: "24px", textAlign: "left",
  textBoxTrim: "trim-both", textBoxEdge: "cap alphabetic",
};

export const PROFILE_CONTENT_SX = {
  fontFamily: '"Be Vietnam Pro", sans-serif',
  "& .MuiFormControl-root .MuiOutlinedInput-root": {
    minHeight: 42, borderRadius: "8px", backgroundColor: "#FFFFFF",
    boxShadow: "0 1px 2px rgba(16,24,40,0.05)",
    fontFamily: '"Be Vietnam Pro", sans-serif', fontSize: 14, fontWeight: 400,
    color: PROFILE_COLORS.text,
  },
  "& .MuiFormControl-root .MuiOutlinedInput-root:not(.MuiInputBase-multiline)": {
    height: 42,
  },
  "& .MuiFormControl-root .MuiOutlinedInput-root:has(.MuiChip-root)": {
    height: "auto", minHeight: 42,
  },
  "& .MuiFormControl-root .MuiOutlinedInput-notchedOutline": {
    borderColor: `${PROFILE_COLORS.border} !important`, borderWidth: 1,
  },
  "& .MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${PROFILE_COLORS.link} !important`,
  },
  "& .MuiFormControl-root .MuiOutlinedInput-input, & .MuiFormControl-root .MuiSelect-select": {
    fontFamily: '"Be Vietnam Pro", sans-serif', fontSize: 14, fontWeight: 400,
    lineHeight: "24px", color: PROFILE_COLORS.text, padding: "8px 16px",
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "0 40px 0 0" },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input": {
    padding: "8px 16px !important", fontSize: 14, fontWeight: 400,
  },
  "& .MuiFormControl-root .MuiInputBase-multiline": { padding: "16px", height: "auto" },
  "& .MuiFormControl-root .MuiInputBase-multiline textarea": { padding: 0, lineHeight: "24px" },
  "& .MuiInputBase-input::placeholder": { color: PROFILE_COLORS.muted, opacity: 1 },
  "& .MuiFormControl-root input[value^='http'], & .MuiFormControl-root input[value^='www.'], & .MuiFormControl-root input[type='url'], & .MuiFormControl-root input[type='email'], & a[href]": {
    color: PROFILE_COLORS.link,
  },
  "& .profile-field-label": PROFILE_LABEL_SX,
  "& .profile-section-title": { fontSize: 20, fontWeight: 700, lineHeight: "30px", color: PROFILE_COLORS.label },
};
